import $ from "jquery";
import parsley from "parsleyjs";

let $contactForm = $(".contact-form");

const Contact = {
    init: function () {
        Contact.form();
    },

    generateError: (element, errorMessage) => {
        $(element).after(`
            <ul class="parsley-errors-list filled" aria-hidden="false">
                <li class="parsley-required">${errorMessage}</li>
            </ul>
        `);
    },

    form: function () {
        Parsley.on("form:submit", function () {
            var $form = $contactForm;
            var $btnSubmit = $form.find('button[type="submit"]');
            var $alertSuccess = $form.find(".alert-success");
            var $alertDanger = $form.find(".alert-danger");

            const $inputName = $form.find('[name="name"]');
            const $inputEmail = $form.find('[name="email"]');
            const $selectSubject = $form.find('[name="subject"]');
            const $inputTelephone = $form.find('[name="telephone"]');
            const $textareaMessage = $form.find('[name="message"]');

            $form.find(".parsley-errors-list").remove();
            $alertSuccess.addClass("hide");
            $alertDanger.addClass("hide");
            $btnSubmit.attr("disabled", "disabled");
            $btnSubmit.addClass("is-loading");

            $.ajax({
                type: $form.attr("method"),
                url: $form.attr("action"),
                data: $form.serialize(),
                success: (res, status) => {
                    setTimeout(() => {
                        $btnSubmit.removeAttr("disabled");
                        $btnSubmit.removeClass("is-loading");
                    }, 200);

                    if (status === "success") {
                        $alertSuccess.removeClass("hide");

                        // Clear the form.
                        $form[0].reset();
                    }

                    console.log("submitted");
                },
                error: (err) => {
                    console.log("submitted");

                    setTimeout(() => {
                        $btnSubmit.removeAttr("disabled");
                        $btnSubmit.removeClass("is-loading");
                    }, 200);

                    if (err.responseJSON && err.responseJSON.errors) {
                        if (err.responseJSON.errors.name) {
                            $inputName.addClass("parsley-error");
                            Contact.generateError(
                                $inputName,
                                err.responseJSON.errors.name[0]
                            );
                        }

                        if (err.responseJSON.errors.email) {
                            $inputEmail.addClass("parsley-error");
                            Contact.generateError(
                                $inputEmail,
                                err.responseJSON.errors.email[0]
                            );
                        }

                        if (err.responseJSON.errors.subject) {
                            $selectSubject.addClass("parsley-error");
                            Contact.generateError(
                                $selectSubject,
                                err.responseJSON.errors.subject[0]
                            );
                        }

                        if (err.responseJSON.errors.telephone) {
                            $inputTelephone.addClass("parsley-error");
                            Contact.generateError(
                                $inputTelephone,
                                err.responseJSON.errors.telephone[0]
                            );
                        }

                        if (err.responseJSON.errors.message) {
                            $textareaMessage.addClass("parsley-error");
                            Contact.generateError(
                                $textareaMessage,
                                err.responseJSON.errors.message[0]
                            );
                        }

                        if (err.responseJSON.errors["g-recaptcha-response"]) {
                            $alertDanger.removeClass("hide");
                            console.log(
                                err.responseJSON.errors["g-recaptcha-response"]
                            );
                        }
                    } else {
                        $alertDanger.removeClass("hide");
                    }
                },
            });

            return false;
        });
    },
};

export default Contact;
